<template>
    <div>

        <div class="wrap-content-policy">
            <div class="top-title-policy">
                {{ title }}
            </div>
            <div class="title-policy">
                [개인정보 보유 및 이용기간]
            </div>
            <!--                        <div class="wrap-text-policy">-->
            <!--                            <div>-->
            <!--                                ① 회사는 법령에 따른 개인정보 보유·이용기간 또는 이용자로부터 개인정보 수집시 동의받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ② 회사의 개인정보 처리 및 보유기간은 다음과 같습니다.-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                1. 회원가입 및 관리 : 회원탈퇴시까지. 다만, 다음 사유에 해당하는 경우에는 해당 사유 종료시까지-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                가. 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료시까지-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                나. 서비스 이용에 따른 채권·채무관계가 잔존하는 경우 정산시까지-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                1. 관련 법령에 따라 보유하는 경우-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                가. 전자상거래법에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ● 표시·광고에 관한 기록 : 6월-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ● 계약 또는 청약철회 등에 관한 기록: 5년-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ● 대금결제 및 재화 등의 공급에 관한 기록 : 5년-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ● 소비자 불만 또는 분쟁처리에 관한 기록 : 3년-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                나. 통신비밀보호법 제41조에 따른 통신사실확인자료 보관-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ● 가입자 전기통신일시, 개시·종료 시간, 상대방 가입자번호, 사용도수 : 1년-->
            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ● 컴퓨터 통신, 인터넷 로그기록자료, 접속지 추적 자료 : 3개월-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ③ 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제29조 제2항에 따라 장기간(1년 이상) 서비스 미이용자의 개인정보 보호를 위하여 다른 이용자의 개인정보와 분리하여 별도로 보관합니다.-->
            <!--                            </div>-->
            <!--                        </div>-->

            <!--                        <div class="title-policy">-->
            <!--                            [개인정보의 파기 절차 및 방법]-->
            <!--                        </div>-->

            <!--                        <div class="wrap-text-policy">-->

            <!--                            <div>-->
            <!--                                ① 원칙적으로 이용자의 개인정보는 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기됩니다.-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ② 이용자로부터 동의를 받은 개인정보는 보유기간이 경과하거나 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 보관하는 경우에는, 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                ③ 개인정보의 파기 절차 및 방법은 다음과 같습니다.-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                1. 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 해당 개인정보를 파기합니다.-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                2. 회사는 다음 각 호의 방법으로 개인정보를 파기합니다.-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                가. 종이에 기록, 저장된 개인정보 : 분쇄기로 분쇄하거나 소각을 통하여 파기-->

            <!--                            </div>-->
            <!--                            <div>-->
            <!--                                나. 전자적 파일 형태로 저장된 개인정보: 기록을 재생할 수 없도록 로우레벨포맷(Low Level Format) 등 기술적 방법을 사용하여 삭제-->
            <!--                            </div>-->
            <!--                        </div>-->
            <div class="wrap-text-policy" v-html="content">
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";

export default {
    name: "Policy",
    data() {
        return {
            title: this.$route.meta.title,
            content: '',
        }
    },

    beforeCreate() {
    },
    created() {
        this.getConfig();

    },
    mounted() {

    },
    computed: {},
    methods: {
        replaceBr(content) {
            if (util.isEmpty(content)) {
                return '';
            }
            return content.replace(/(\n|\r\n)/g, '<br>');
        },
        getConfig() {
            try {
                this.$api.$terms.getConfigTerm().then(data => {
                    if (data.Data.Result.Info.Type === 1) {
                        let res = data.Data.Result.List[0];
                        this.content = res.cs_privacy;
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },

    }

}
</script>

<style scoped>

</style>